module.exports = __webpack_public_path__ + "static/wild_magic_mtg_afr-eb031c589949acb69b9cd7ca5e986061.jpg";